import { onMounted, onUnmounted, ref, type Ref } from "vue";

type Dimension = { width: number; height: number };

export const useResponsiveContainer = (div: Ref<HTMLElement | undefined>) => {
	const dimension = ref<Dimension>({ width: 0, height: 0 });

	function setDimension() {
		if (!div.value) return;
		dimension.value = {
			width: div.value.clientWidth,
			height: div.value.clientHeight,
		};
	}

	if (typeof ResizeObserver !== "undefined") {
		const observer = new ResizeObserver(setDimension);
		onMounted(() => {
			if (!div.value) return;
			setDimension();
			observer.observe(div.value);
		});
		onUnmounted(() => {
			observer.disconnect();
		});
	} else {
		onMounted(setDimension);
	}

	return { dimension };
};
